import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import {
  getCurrencyConversionQueryOptions,
  organizationQueryOptions,
} from '@/core/components/organizations/organizationQueryOptions'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const organizationsSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z
    .enum([
      'name',
      'image',
      'id',
      'fee',
      'completedStays',
      'revenueOnCompletedStays',
      'bookingsRevenue',
      'totalBookings',
      'invoiceRevenue',
      'sitesCreated',
    ])
    .catch('name'),
  orderBy: z.enum(['asc', 'desc']).catch('asc'),
  startDate: z.string(),
  endDate: z.string(),
})

export const Route = createFileRoute('/_layout/dashboard/organizations/')({
  validateSearch: (search) => organizationsSearchSchema.parse(search),
  beforeLoad: ({ context: { auth }, location }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
        search: { redirect: location.href },
      })
    }
    if (
      auth.user?.role !== Role['Internal'] &&
      auth.user?.role !== Role['Reseller']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loaderDeps: ({ search }) => {
    return {
      startDate: search.startDate,
      endDate: search.endDate,
    }
  },
  loader: ({ context: { queryClient, auth }, deps }) => {
    const orgs = queryClient.ensureQueryData(
      organizationQueryOptions(auth.token!, deps.startDate, deps.endDate)
    )
    const currencyConversion = queryClient.ensureQueryData(
      getCurrencyConversionQueryOptions()
    )

    return {
      orgs,
      currencyConversion,
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
